module.exports = __webpack_public_path__ + "static/img/avatar.71b4f1d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/static/avatar.jpeg
// module id = WS/w
// module chunks = 1